module.exports = __webpack_public_path__ + "img/good2.1eba91ad.png";